module.exports = __webpack_public_path__ + "static/media/cloud_infrastructure.e3a7262d.svg";